if (!customElements.get('ses-max-promo')) {
  customElements.define('ses-max-promo', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.copy = JSON.parse(this.dataset.copy);
      this.root = this.closest('ses-max-preorder');
      this.scope = this.closest('[id^="MainProduct-"]');
      this.input = this.querySelector('[data-promo-code]');
      this.status = this.querySelector('[data-promo-status]');
      this.applyButton = this.querySelector('[data-promo-apply]');
      this.removeButton = this.querySelector('[data-promo-remove]');
      this.hidden = false;
      this.applyButton.addEventListener('click', () => this.activate());
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); this.activate(); }
      });
      this.removeButton.addEventListener('click', () => this.deactivate());
      this.scope.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
        form.addEventListener('submit', event => this.submit(event, form), true);
      });
    }

    async matches(code) {
      const bytes = new TextEncoder().encode(code.trim().toUpperCase());
      const digest = await crypto.subtle.digest('SHA-256', bytes);
      return [...new Uint8Array(digest)].map(byte => byte.toString(16).padStart(2, '0')).join('') === '783d4208475df605834e81dffb5869afa413f0a8bc55ac37056408f0f28f57c9';
    }

    async activate() {
      this.applyButton.disabled = true;
      try {
        if (!await this.matches(this.input.value)) {
          this.status.textContent = this.copy.invalid;
          this.status.dataset.error = 'true';
          return;
        }
        this.code = this.input.value.trim();
        this.input.readOnly = true;
        this.applyButton.hidden = true;
        this.removeButton.hidden = false;
        this.status.textContent = this.copy.active;
        this.status.dataset.error = 'false';
      } finally {
        this.applyButton.disabled = false;
      }
    }

    deactivate() {
      this.code = '';
      this.input.value = '';
      this.input.readOnly = false;
      this.applyButton.hidden = false;
      this.removeButton.hidden = true;
      this.status.textContent = '';
      this.status.dataset.error = 'false';
    }

    async request(path, data) {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}${path}`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data)
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || this.copy.failed);
      return result;
    }

    async submit(event, form) {
      if (!this.code) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy) return;
      this.busy = true;
      const button = form.querySelector('button[name="add"]');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      const drawer = document.querySelector('cart-drawer');
      drawer?.setActiveElement(button);
      let added;
      try {
        const body = new FormData(form);
        body.set(`properties[${this.copy.property}]`, this.copy.order_note);
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body
        });
        added = await response.json();
        if (!response.ok || added.status) throw new Error(added.description || this.copy.failed);
        const current = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json();
        const codes = [...new Set([...(current.discount_codes || []).map(discount => discount.code), this.code])];
        const sections = drawer?.getSectionsToRender().map(section => section.id) || [];
        const cart = await this.request('cart/update.js', { discount: codes.join(','), sections, sections_url: location.pathname });
        const applied = cart.discount_codes?.some(discount => discount.code.toUpperCase() === this.code.toUpperCase() && discount.applicable);
        if (!applied) {
          const line = cart.items.find(item => item.key === added.key);
          if (line) {
            const properties = { ...line.properties };
            delete properties[this.copy.property];
            await this.request('cart/change.js', { id: line.key, quantity: line.quantity, properties });
          }
          throw new Error(this.copy.failed);
        }
        this.status.textContent = this.copy.applied;
        this.status.dataset.error = 'false';
        document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart, sectionId: this.scope.id } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        if (drawer && sections.every(id => cart.sections?.[id])) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ ...cart, id: added.id });
        } else {
          location.href = `${window.Shopify?.routes?.root || '/'}cart`;
        }
      } catch (error) {
        this.status.textContent = added?.key ? this.copy.added_without_discount : this.copy.failed;
        this.status.dataset.error = 'true';
        this.scrollIntoView({ block: 'center', behavior: 'smooth' });
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        this.busy = false;
      }
    }
  });
}
